<template>
  <div class="chart-panel">
    <div class="chart-panel__wrapper">
      <VueApexCharts
        v-if="!loading"
        :key="chartKey"
        :options="chartOptions"
        :series="series"
        :height="chartHeight"
      />
      <slot name="legends" />
    </div>

    <div class="chart-panel__menu">
      <div class="chart-panel__menu-left">
        <div class="chart-panel__title">
          {{ title }}
        </div>
      </div>
      <div
        id="chart-control"
        class="chart-panel__menu-right"
      >
        <RefreshIcon @click="emit('refresh')" />
        <CalendarInput
          :model-value="date"
          @update:model-value="emit('update:date', $event)"
        />
        <slot name="controls" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";
import VueApexCharts from "vue3-apexcharts";
import CalendarInput from "./blocks/CalendarInput.vue";
import RefreshIcon from "@/components/Icons/RefreshIcon.vue";

defineProps({
  title: {
    type: String,
    required: true
  },
  date: {
    type: Array,
    required: true
  },
  chartHeight: {
    type: [Number, String],
    required: true
  },
  chartKey: {
    type: [String, Number],
    default: 0
  },
  chartOptions: {
    type: Object,
    required: true
  },
  series: {
    type: Array,
    required: true
  },
  loading: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(["refresh", "update:date"]);
</script>

<style lang="scss" scoped>
.chart-panel {
  height: 444px;
  position: relative;
  background: var(--background-bg-white);
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.14);
  margin-bottom: 5px;

  &__title {
    font-size: 16px;
    font-weight: 700;
    font-family: Roboto, sans-serif;
    line-height: 22px;
  }

  &__wrapper {
    z-index: 10;
  }

  &__menu {
    display: flex;
    position: absolute;
    align-items: center;
    top: 24px;
    height: 42px;
    width: 100%;
    left: 0;
    padding: 0 24px;
    justify-content: space-between;

    &-left {
      display: flex;
      gap: 20px;
    }

    &-right {
      display: flex;
      gap: 14px;
    }
  }

  &__legends {
    position: absolute;
    bottom: 25px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    margin: auto;

    &-item {
      display: flex;
      gap: 4px;
      align-items: center;
    }

    svg {
      width: 20px;
      height: 20px;
    }
  }
}
</style>
